import { createTrackingUtils } from "..";
import { useSelector } from "react-redux";
import { getGeniusLevel } from "../../../store/user/selectors";
import useProfiler from "../../../hooks/useProfiler";

const utils = createTrackingUtils({
  name: "web_flights_fd_genius_saving_badge_percentage",
  stages: {
    land_on_fd: 1,
    fare_discount_available: 2,
    ddot: 3,
    mdot: 4,
    genius_one: 5,
    genius_two: 6,
    genius_three: 7
  },
  defaultStage: 1,
  goals: {}
});

export const useTrackStages = () => {
  const geniusLevel = useSelector(getGeniusLevel);
  const { isMobile } = useProfiler();

  utils.stages.fare_discount_available();
  isMobile() ? utils.stages.mdot() : utils.stages.ddot();
  if (geniusLevel == 1) {
    utils.stages.genius_one();
  } else if (geniusLevel == 2) {
    utils.stages.genius_two();
  } else if (geniusLevel == 3) {
    utils.stages.genius_three();
  }
};

export default { useTrackStages, ...utils };
